import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import {
  activateExchangeRate,
  deactivateExchangeRate,
} from "../../../../redux/settings";
import RootState from "../../../../redux/type";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
  detail?: any;
}

const DeleteRateModal = ({
  onClose,
  visible,
  detail,
  onFinish,
}: myComponentProps) => {
  const { loadingDelete } = useSelector((state: RootState) => state.settings);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const obj = {
      id: detail?.id,
    };
    const data =
      detail?.status === "active"
        ? await dispatch(deactivateExchangeRate(obj) as any)
        : await dispatch(activateExchangeRate(obj) as any);

    if (data?.payload?.data?.status) {
      onFinish && onFinish();
    }
  };

  return (
    <>
      <ReuseModal
        loading={loadingDelete}
        visible={visible}
        onClose={onClose}
        onBtnClick={handleSubmit}
        deleteType
        btnColor={detail?.status === "active" ? "" : "black-light"}
        btnLabel={
          detail?.status === "active" ? "Deactivate Rate" : "Activate Rate"
        }
        title={
          detail?.status === "active"
            ? "Deactivate Exchange Rate"
            : "Activate Exchange Rate"
        }
        deleteText={
          detail?.status === "active"
            ? "Are you sure you want to deactivate this exchange rate? Once confirmed, this would permanently deactivate this information from the database."
            : "Are you sure you want to activate this exchange rate? Once confirmed, this would permanently activate this information from the database."
        }
      />
    </>
  );
};

export default DeleteRateModal;
